import React from "react";
import classNames from "classnames";

import styles from "./MenuIcon.module.scss";

interface MenuIconProps extends React.HTMLAttributes<HTMLButtonElement> {
  open?: boolean;
}

const MenuIcon: React.FC<MenuIconProps> = ({
  open = false,
  className,
  ...props
}) => {
  return (
    <button
      className={classNames(
        styles.menuIcon,
        { [styles.open]: open },
        className
      )}
      {...props}
    >
      <svg
        viewBox="0 0 57 7"
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
      >
        <path
          d="M56.936 0L0 .802v4.63l56.937 1.266v-6.7z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </svg>

      <svg
        viewBox="0 0 57 7"
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
      >
        <path
          d="M0 6.699l56.937-.805V1.266L0 0v6.699z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </svg>

      <svg
        viewBox="0 0 57 7"
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
      >
        <path
          d="M0 .804v4.629l56.937 1.266V0L0 .804z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </svg>
    </button>
  );
};

export { MenuIcon };
